/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_No_DataInputs */

const vi_user_no_data = /** @type {(inputs: User_No_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có người dùng nào`)
};

/**

* @param {User_No_DataInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const user_no_data = /** @type {((inputs?: User_No_DataInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_No_DataInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_user_no_data(inputs)
});